module.exports = __webpack_public_path__ + "static/media/bandcamp.b526f5af.svg";